import { Card, Collapse, Tabs, Typography, Modal, Tag, Tooltip } from "antd"
import { ButtonLZ } from "../../../components/design/Buttons/ButtonLZ"
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined, PlusOutlined, StarFilled, StarOutlined, PhoneOutlined, SoundOutlined, InfoCircleOutlined, SettingOutlined } from "@ant-design/icons";
import { authFetch } from "../../../../common/request/authFetch";
import { AddClientWebModal } from "./modal/AddClientWebModal";
import { authRequest } from "../../../../common/request/authRequest";
import { ModuleAccessGate } from "../../common/roles/ModuleAccessGate";
import { PageTitle } from "../../common/PageTitle";

const { Paragraph, Text: AntText, Title } = Typography;

const WEB_PAGE_INFO = [
	'En el SEO local, la web juega un papel muy importante para adquirir impresiones tanto en Google Maps como en Google Search (o tráfico orgánico local).',
	'Para ello se recomienda:',
	[
		'- Tener en cada ficha una página web vinculada con contenido local y original, testimonios, etc...',        
        '- Mantener consistencia entre la ficha y la web, sobre todo a nivel de NAP (Name, Address, Phone).',
		'- Si se trata de una empresa con múltiples locales, como una franquicia: Incluir un buscador de locales y que cada ficha tenga su propia URL (o al menos una URL por región geográfica).',		
	].join('\n'),
	'Los widgets de localiza.me vienen a facilitar todo esto con una integración muy sencilla y alimentándose del contenido de Google Business Profile previamente importado.',
].join('\n\n');

const appleStyles = {
    card: {
        borderRadius: '20px',
        border: '1px solid #d2d2d7',
        boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
        padding: '10px'
    },
    stepNumber: {
        color: '#86868b',
        fontWeight: 500,
        fontSize: '12px',
        textTransform: 'uppercase' as const,
        letterSpacing: '1.2px',
        display: 'block',
        marginBottom: '4px'
    },
    stepTitle: {
        color: '#1d1d1f',
        fontSize: '20px',
        fontWeight: 600,
        marginBottom: '20px',
        marginTop: '0px'
    },
    urlRow: {
        background: '#ffffff',
        padding: '14px 18px',
        borderRadius: '12px',
        border: '1px solid #e5e5e7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
        transition: 'all 0.3s ease'
    },
    previewBox: {
        background: '#f5f5f7',
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid #d2d2d7',
        marginBottom: '24px',
        overflow: 'hidden'
    },
    codeSnippet: {
        background: '#1d1d1f',
        padding: '16px',
        borderRadius: '12px',
        color: '#f5f5f7',
        marginTop: '8px',
        fontFamily: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace'
    }
};
export const WidgetWebs = () => (
    <ModuleAccessGate module='WEB_SYNC' title='Widgets para Web' pageInfo={WEB_PAGE_INFO}>
        <WidgetWebsContent />
    </ModuleAccessGate>
);

const WidgetWebsContent = () => {

    const [addWeb, setAddWeb] = useState<string | null>(null);
    const [updateData, setUpdateData] = useState(false);
    const [storeCode, setStoreCode] = useState(null);
    const { projectGroup } = useAuth();
    const { t } = useTranslation();

    const { data, isLoading }: any = useFetch(
        `${process.env.REACT_APP_API}/client/web/projects/${projectGroup.project}`,
        {},
        [updateData],
    );

    useEffect(() => {

          authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/first-location`, {}).then((data) => {            
              setStoreCode(data);
            }
          )         
      }, [projectGroup.group])

    const deleteWeb = async (id: string) => {
        await authFetch(`${process.env.REACT_APP_API}/client/web/projects/${projectGroup.project}?id=${id}`,{ method: 'DELETE' }).then(()=>{
            setUpdateData(!updateData)
        })
    }

    return (
        <Card className='main-card-content'>
            
            {/*<PageConfigScope/>*/}
            <PageTitle title='Widgets para Web' pageInfo={WEB_PAGE_INFO} />
            
            <br/>
            {/* PASO 1: GESTIÓN DE URLS */}
            <section>
                <AntText style={appleStyles.stepNumber}>Paso 01</AntText>
                <Title level={4} style={appleStyles.stepTitle}>Configura tu WIDGET_KEY</Title>
                
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        {data?.map((clientWeb: any) => {
                                return                                 (
                                <div key={clientWeb.id} style={appleStyles.urlRow}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <AntText strong style={{ fontSize: '15px' }}>{clientWeb.url}</AntText>
                                    <Tag style={{ background: '#f5f5f7', borderRadius: '6px', border: 'none', color: '#424245' }}>
                                        <span style={{ color: '#86868b', fontWeight: 400 }}>Widget_KEY:</span> {clientWeb.id}
                                    </Tag>
                                </div>                              
                                <div style={{ display: 'flex', gap: '16px', fontSize: '16px', color: '#86868b' }}>                                        
                                        <DeleteOutlined className="icon-button-danger" 
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: '¿Eliminar esta web?',
                                                    content: 'Esta acción desactivará los widgets instalados en esta URL.',
                                                    okText: t('dictionary.confirm'),
                                                    okType: 'danger',
                                                    cancelText: t('dictionary.cancel'),
                                                    onOk: () => deleteWeb(clientWeb.id),
                                                });
                                            }} 
                                        />
                                    </div>                               
                            </div>)
                            })}                        
                    </div>
                            
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ButtonLZ type="ghost" size="small" onClick={() => { setAddWeb('') }} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                            <PlusOutlined/> Añadir dominio
                        </ButtonLZ>
                    </div>                    
                </div>                    
            </section>
            
            <br/>
            {/* PASO 2: SELECCIÓN DE WIDGETS */}
            <AntText style={appleStyles.stepNumber}>Paso 02</AntText>
            <Title level={4} style={appleStyles.stepTitle}>
                Elige tu Widget{' '}
                <Tooltip title="Estos widgets son genéricos, si necesitas adaptar el widget al diseño de tu web haz llegar tus requerimientos al equipo de localiza.me">
                    <InfoCircleOutlined style={{ fontSize: '16px', color: '#86868b', cursor: 'help', marginLeft: '8px' }} />
                </Tooltip>
            </Title>
            
            {!!data && data.length > 0 && 
                <div style={{ width: '100%' }}>

                <Tabs style={{ marginTop: 20 }} defaultActiveKey="1" >

                    <Tabs.TabPane
                        tab={<h3><StarOutlined/>Reseñas</h3>}
                        key="1">
                            
                        <AntText style={appleStyles.stepNumber}>Vista Previa</AntText>
                
                        <div style={{ border: '3px dashed lightgrey', padding: '10px', marginBottom: '10px' }}>
                            <iframe
                                style={{ height: '300px', width: '100%' }}
                                src={`${process.env.REACT_APP_SITES}/widgets/reviews/${data[0].id}`}
                                title="Widget Reviews">
                            </iframe>
                        </div>
                
                        {/* PASO 3: SELECCIÓN DE WIDGETS */}
                        <AntText style={appleStyles.stepNumber}>Paso 03</AntText>
                        <Title level={4} style={appleStyles.stepTitle}>Inserta el código en tu sitio</Title>
                        <Collapse>
                        <Collapse 
    ghost 
    defaultActiveKey={['1']} 
    expandIconPosition="end" 
    style={{ background: '#f5f5f7', borderRadius: '12px', marginTop: '16px' }}
>
    <Collapse.Panel 
        key="1" 
        header={<span style={{ fontWeight: 600, color: '#1d1d1f' }}>Instrucciones de instalación</span>}
    >
        <div style={{ padding: '10px 0' }}>
            
            {/* BLOQUE 1: SCRIPT GLOBAL */}
            <div style={{ marginBottom: '24px' }}>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    1. Script de reseñas
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                        {'// Importar una sola vez en el header'}
                    </AntText>
                    <Paragraph 
                        copyable={{ tooltips: ['Copiar', '¡Copiado!'] }}
                        style={{ color: '#d1d1d6', margin: 0, fontFamily: 'SFMono-Regular, Consolas, monospace', fontSize: '14px' }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;script</span> <span style={{ color: '#79c0ff' }}>src</span>=<span style={{ color: '#a5d6ff' }}>"{process.env.REACT_APP_SITES}/widgets-reviews.js"</span><span style={{ color: '#ff7b72' }}>&gt;&lt;/script&gt;</span>
                    </Paragraph>
                </div>
            </div>

            {/* BLOQUE 2: TAG HTML PERSONALIZABLE */}
            <div>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    2. Componente del Widget
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    {/* Documentación rápida dentro del bloque negro */}
                    <div style={{ marginBottom: '15px', borderLeft: '2px solid #30363d', paddingLeft: '12px' }}>
                        <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                            {'// Situar en el lugar del html donde se quiere incluir el widget'}
                        </AntText>
                        <AntText style={{ color: '#8b949e', fontSize: '12px', display: 'block' }}>
                            <span style={{ color: '#d29922' }}>@optional</span> <b>storeCode</b>: Código de tienda en GBP (filtrado local)
                        </AntText>
                        <AntText style={{ color: '#8b949e', fontSize: '12px', display: 'block' }}>
                            <span style={{ color: '#d29922' }}>@optional</span> <b>locality</b>: Personalizar nombre del negocio en el widget
                        </AntText>
                    </div>
                    
                    <Paragraph 
                        copyable 
                        style={{ 
                            margin: 0, 
                            fontSize: '14px',
                            fontFamily: 'SFMono-Regular, Consolas, monospace',
                            color: '#d1d1d6'
                        }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;reviews-widget</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>id</span>=<span style={{ color: '#a5d6ff' }}>'{data[0].id}'</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>storeCode</span>=<span style={{ color: '#a5d6ff' }}>'OPCIONAL_CODIGO_TIENDA'</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>locality</span>=<span style={{ color: '#a5d6ff' }}>'OPCIONAL_NOMBRE_NEGOCIO'</span>
                        <br />
                        <span style={{ color: '#ff7b72' }}>&gt;&lt;/reviews-widget&gt;</span>
                    </Paragraph>
                </div>
            </div>

        </div>
    </Collapse.Panel>
</Collapse>

<style>{`
    /* Asegura que el icono de copiar de Ant Design sea visible en fondo oscuro */
    .ant-typography-copy {
        color: #8b949e !important;
    }
    .ant-typography-copy:hover {
        color: #ffffff !important;
    }
`}</style>

                        </Collapse>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={<h3><PhoneOutlined/>Contacto</h3>}
                        key="2">
                        <AntText style={appleStyles.stepNumber}>Vista Previa</AntText>

                        {storeCode && 
                            <div style={{ border: '3px dashed lightgrey', padding: '10px', marginBottom: '10px' }}>
                                <iframe
                                    style={{ height: '600px', width: '100%' }}
                                    src={`${process.env.REACT_APP_SITES}/widgets/contact/${data[0].id}?storeCode=${storeCode}`}
                                    title="Widget Contact">
                                </iframe>
                            </div>
                        }

                        {/* PASO 3: SELECCIÓN DE WIDGETS */}
                        <AntText style={appleStyles.stepNumber}>Paso 03</AntText>
                        <Title level={4} style={appleStyles.stepTitle}>Inserta el código en tu sitio</Title>
                        <Collapse 
    ghost 
    defaultActiveKey={['1']} 
    expandIconPosition="end" 
    style={{ background: '#f5f5f7', borderRadius: '12px', marginTop: '16px' }}
>
    <Collapse.Panel 
        key="1" 
        header={<span style={{ fontWeight: 600, color: '#1d1d1f' }}>Código ejemplo del widget de datos de contacto</span>}
    >
        <div style={{ padding: '10px 0' }}>
            
            {/* BLOQUE 1: SCRIPT CONTACTO */}
            <div style={{ marginBottom: '24px' }}>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    1. Script de Contacto
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                        {'// Importar una sola vez en el header'}
                    </AntText>
                    <Paragraph 
                        copyable={{ tooltips: ['Copiar', '¡Copiado!'] }}
                        style={{ color: '#d1d1d6', margin: 0, fontFamily: 'SFMono-Regular, Consolas, monospace', fontSize: '14px' }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;script</span> <span style={{ color: '#79c0ff' }}>src</span>=<span style={{ color: '#a5d6ff' }}>"{process.env.REACT_APP_SITES}/widgets-contact.js"</span><span style={{ color: '#ff7b72' }}>&gt;&lt;/script&gt;</span>
                    </Paragraph>
                </div>
            </div>

            {/* BLOQUE 2: TAG CONTACTO */}
            <div>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    2. Componente del Widget
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>                    
                    <div style={{ marginBottom: '15px', borderLeft: '2px solid #30363d', paddingLeft: '12px' }}>
                        <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                            {'// Situar en el lugar del html donde se quiere incluir el widget'}
                        </AntText>
                        <AntText style={{ color: '#8b949e', fontSize: '12px', display: 'block' }}>
                            <span style={{ color: '#d29922' }}>@optional</span> <b>storeCode</b>: Código de tienda en GBP (filtrado local)
                        </AntText>
                    </div>
                    
                    <Paragraph 
                        copyable 
                        style={{ 
                            margin: 0, 
                            fontSize: '14px',
                            fontFamily: 'SFMono-Regular, Consolas, monospace',
                            color: '#d1d1d6'
                        }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;contact-widget</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>id</span>=<span style={{ color: '#a5d6ff' }}>'{data[0].id}'</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>storeCode</span>=<span style={{ color: '#a5d6ff' }}>'OPCIONAL_CODIGO_TIENDA'</span>
                        <br />
                        <span style={{ color: '#ff7b72' }}>&gt;&lt;/contact-widget&gt;</span>
                    </Paragraph>
                </div>
            </div>

        </div>
    </Collapse.Panel>
</Collapse>

<style>{`
    /* Consistencia para los iconos de copia en fondos oscuros */
    .ant-typography-copy {
        color: #8b949e !important;
    }
    .ant-typography-copy:hover {
        color: #ffffff !important;
    }
`}</style>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={<h3><SoundOutlined/>Posts</h3>}
                        key="3">
                        <AntText style={appleStyles.stepNumber}>Vista Previa</AntText>

                        {storeCode && 
                            <div style={{ border: '3px dashed lightgrey', padding: '10px', marginBottom: '10px' }}>
                                <iframe
                                    style={{ height: '600px', width: '100%' }}
                                    src={`${process.env.REACT_APP_SITES}/widgets/posts/${data[0].id}?storeCode=${storeCode}`}
                                    title="Post Reviews">
                                </iframe>
                            </div>
                        }

                        {/* PASO 3: SELECCIÓN DE WIDGETS */}
                        <AntText style={appleStyles.stepNumber}>Paso 03</AntText>
                        <Title level={4} style={appleStyles.stepTitle}>Inserta el código en tu sitio</Title>
                        <Collapse>
                        <Collapse 
    ghost 
    defaultActiveKey={['1']} 
    expandIconPosition="end" 
    style={{ background: '#f5f5f7', borderRadius: '12px', marginTop: '16px' }}
>
    <Collapse.Panel 
        key="1" 
        header={<span style={{ fontWeight: 600, color: '#1d1d1f' }}>Código ejemplo del widget de publicaciones</span>}
    >
        <div style={{ padding: '10px 0' }}>
            
            {/* BLOQUE 1: SCRIPT POSTS */}
            <div style={{ marginBottom: '24px' }}>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    1. Script de Publicaciones
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                        {'// Importar una sola vez en el header'}
                    </AntText>
                    <Paragraph 
                        copyable={{ tooltips: ['Copiar', '¡Copiado!'] }}
                        style={{ color: '#d1d1d6', margin: 0, fontFamily: 'SFMono-Regular, Consolas, monospace', fontSize: '14px' }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;script</span> <span style={{ color: '#79c0ff' }}>src</span>=<span style={{ color: '#a5d6ff' }}>"{process.env.REACT_APP_SITES}/widgets-posts.js"</span><span style={{ color: '#ff7b72' }}>&gt;&lt;/script&gt;</span>
                    </Paragraph>
                </div>
            </div>

            {/* BLOQUE 2: TAG POSTS */}
            <div>
                <AntText strong style={{ display: 'block', marginBottom: '8px', color: '#86868b', fontSize: '12px', textTransform: 'uppercase' }}>
                    2. Componente del Widget
                </AntText>
                <div style={{ 
                    background: '#1d1d1f', 
                    borderRadius: '12px', 
                    padding: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ marginBottom: '15px', borderLeft: '2px solid #30363d', paddingLeft: '12px' }}>
                        <AntText style={{ color: '#59595e', fontSize: '13px', display: 'block', marginBottom: '10px', fontFamily: 'monospace', fontStyle: 'italic' }}>
                            {'// Situar en el lugar del html donde se quiere incluir el widget'}
                        </AntText>
                        <AntText style={{ color: '#8b949e', fontSize: '12px', display: 'block' }}>
                            <span style={{ color: '#d29922' }}>@optional</span> <b>storeCode</b>: Código de tienda en GBP (filtrado local)
                        </AntText>
                        <AntText style={{ color: '#8b949e', fontSize: '12px', display: 'block' }}>
                            <span style={{ color: '#d29922' }}>@optional</span> <b>locality</b>: Personalizar nombre del negocio en el widget
                        </AntText>
                    </div>
                    
                    <Paragraph 
                        copyable 
                        style={{ 
                            margin: 0, 
                            fontSize: '14px',
                            fontFamily: 'SFMono-Regular, Consolas, monospace',
                            color: '#d1d1d6'
                        }}
                    >
                        <span style={{ color: '#ff7b72' }}>&lt;post-widget</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>id</span>=<span style={{ color: '#a5d6ff' }}>'{data[0].id}'</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>storeCode</span>=<span style={{ color: '#a5d6ff' }}>'OPCIONAL_CODIGO_TIENDA'</span>
                        <br />
                        &nbsp;&nbsp;<span style={{ color: '#79c0ff' }}>locality</span>=<span style={{ color: '#a5d6ff' }}>'OPCIONAL_NOMBRE_NEGOCIO'</span>
                        <br />
                        <span style={{ color: '#ff7b72' }}>&gt;&lt;/post-widget&gt;</span>
                    </Paragraph>
                </div>
            </div>

        </div>
    </Collapse.Panel>
</Collapse>

                        </Collapse>
                    </Tabs.TabPane>
                </Tabs>
            </div>
            }
            {addWeb !== null &&
                <AddClientWebModal
                    url={addWeb}
                    onFinish={() => { setAddWeb(null); setUpdateData(!updateData) }}
                />}
        </Card>
    )
}